import { SkeletonProvider } from './SkeletonProvider';
export class EventimFanSaleProvider extends SkeletonProvider { constructor() { super({ id: 'eventim-fansale', name: 'Eventim FanSale', authStrategy: 'partner_feed', documentationUrl: 'https://www.fansale.de/' }); } }
